import { FetchUtil } from "@/api/fetchutil";

export abstract class GenericServiceBase {
    protected f: FetchUtil;
    constructor(protected endpoint: string) {
        if (endpoint.startsWith('/')) endpoint = endpoint.slice(1, endpoint.length);
        if (endpoint.endsWith('/')) endpoint = endpoint.slice(0, endpoint.length - 1);
        this.endpoint = endpoint;
        this.f = new FetchUtil(((_endpoint: string) => `${window.configs.SERVER_URL_PROD}${endpoint ? '/' : ''}${_endpoint}`)(endpoint))
    }
}

export class GenericService<TCreate extends object, TUpdate extends { id: string }, TResponse extends object> extends GenericServiceBase {

    async create(obj: TCreate): Promise<TResponse> {
        return await this.f.post('/', obj) as TResponse;
    }

    async getAll(): Promise<TResponse[]> {
        return await this.f.get('/', undefined, {resolve404As: [], resolve404AsValue: true}) as TResponse[];
    }

    async getById(id: string): Promise<TResponse|null> {
        return await this.f.get(`/${id}`) as TResponse|null;
    }

    async update(obj: TUpdate): Promise<void> {
        return await this.f.patch(`/${obj.id}`, obj) as void;
    }

    async delete(id: string): Promise<void> {
        return await this.f.delete(`/${id}`) as void;
    }
}

export class GenericServiceWithReturns<TCreate extends object, TUpdate extends { id: string }, TResponse extends object> extends GenericServiceBase {

    async create(obj: TCreate): Promise<TResponse> {
        return await this.f.post('/', obj) as TResponse;
    }

    async getAll(): Promise<TResponse[]> {
        return await this.f.get('/', undefined, {resolve404As: [], resolve404AsValue: true}) as TResponse[];
    }

    async getById(id: string): Promise<TResponse|null> {
        return await this.f.get(`/${id}`) as TResponse|null;
    }

    async update(obj: TUpdate): Promise<TResponse> {
        return await this.f.patch(`/${obj.id}`, obj) as TResponse;
    }

    async delete(id: string): Promise<TResponse> {
        return await this.f.delete(`/${id}`) as TResponse;
    }
}

export class GenericServiceWithoutGetAll<TCreate extends object, TUpdate extends object, TResponse extends object> extends GenericServiceBase {

    async create(obj: TCreate): Promise<TResponse> {
        return await this.f.post('/', obj) as TResponse;
    }

    async getById(id: string): Promise<TResponse|null> {
        return await this.f.get(`/${id}`) as TResponse|null;
    }

    async update(obj: TUpdate, id?: string): Promise<void> {
        //@ts-expect-error yup
        return await this.f.patch(`/${obj?.id || id}`, obj) as void;
    }

    async delete(id: string): Promise<void> {
        return await this.f.delete(`/${id}`) as void;
    }
}
